import MonacoEditor from './Editor';

export { MonacoEditor as default };
